module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-content', {
    staticClass: "page_content"
  }, [_c('div', {
    staticClass: "christmax__box"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "id": "swiperBox",
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', {
    staticClass: "swiper-slide1"
  }, [_c('div', {
    staticClass: "christmax__box__img1 imgbox"
  }, [_c('div', {
    staticClass: "arrow",
    on: {
      "click": function($event) {
        _vm.goToNext(1)
      }
    }
  }, [_c('img', {
    staticClass: "bottom__arrow",
    attrs: {
      "src": require("../../assets/images/christmax/bottom__arrow.gif"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-slide2"
  }, [_c('swiper', {
    ref: "mySwiper2",
    attrs: {
      "id": "swiperBox1",
      "options": _vm.swiperimg2Option
    }
  }, [_c('swiper-slide', {
    staticClass: "swiper-slider"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    staticClass: "title",
    attrs: {
      "src": require("../../assets/images/christmax/title.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img1__box"
  }, [_c('div', {
    staticClass: "right__arrow",
    on: {
      "click": function($event) {
        _vm.goToPre(1)
      }
    }
  })])]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-slider"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    staticClass: "title",
    attrs: {
      "src": require("../../assets/images/christmax/title.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img2__box"
  }, [_c('div', {
    staticClass: "left__arrow",
    on: {
      "click": function($event) {
        _vm.goToPre(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right__arrow",
    on: {
      "click": function($event) {
        _vm.goToPre(2)
      }
    }
  })])]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-slider"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    staticClass: "title",
    attrs: {
      "src": require("../../assets/images/christmax/title.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img3__box"
  }, [_c('div', {
    staticClass: "left__arrow",
    on: {
      "click": function($event) {
        _vm.goToPre(1)
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "arrow__next",
    on: {
      "click": function($event) {
        _vm.goToNext(2)
      }
    }
  }, [_c('img', {
    staticClass: "bottom__arrow",
    attrs: {
      "src": require("../../assets/images/christmax/bottom__arrow.gif"),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-slide3"
  }, [_c('div', {
    staticClass: "christmax__box__img3 imgbox"
  })])], 1)], 1)], 1)]), _vm._v(" "), _c('c-footer', [_c('c-button', {
    staticClass: "bottom__btn",
    nativeOn: {
      "click": function($event) {
        _vm.showDialog($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "serve"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/christmax/serve.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("4001683399")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogVisible),
      expression: "dialogVisible"
    }],
    staticClass: "van-overlay",
    staticStyle: {
      "z-index": "10"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogVisible),
      expression: "dialogVisible"
    }],
    staticClass: "van-dialog",
    staticStyle: {
      "z-index": "11"
    },
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "van-dialog__content"
  }, [_c('img', {
    staticClass: "close-btn",
    attrs: {
      "src": require("../../assets/images/2019-11-11/pre-sale/close-btn.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": require("../../assets/images/christmax/dialog.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "weui-input",
    attrs: {
      "type": "tel",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "get-now",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleDialogClick($event)
      }
    }
  })])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37149c0f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/christmas/index.vue
// module id = 1033
// module chunks = 2